import React, { useState, useEffect } from 'react';
import { getImageUrl } from '../utils/imageUrl';
import config from '../config';
import { Link, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { mesFavoris, supprimerFavori } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { Car, Heart, Trash2 } from 'lucide-react';

const MesFavoris = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [favoris, setFavoris] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    mesFavoris()
      .then(res => setFavoris(res.data.favoris))
      .finally(() => setLoading(false));
  }, [user]);

  const handleSupprimer = async (annonce_id) => {
    try {
      await supprimerFavori(annonce_id);
      setFavoris(favoris.filter(f => f.id !== annonce_id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* Header */}
      <div style={{ background: '#0A0A0A' }} className="py-8 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-white text-2xl font-black">Mes Favoris</h1>
          <p style={{ color: '#F5A623' }} className="text-sm mt-1">
            {favoris.length} véhicule(s) sauvegardé(s)
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        {loading ? (
          <div className="text-center py-12 text-gray-400">Chargement...</div>
        ) : favoris.length === 0 ? (
          <div className="text-center py-12">
            <Heart size={60} className="mx-auto mb-4 text-gray-200" />
            <p className="font-semibold text-gray-500 mb-2">Aucun favori pour le moment</p>
            <p className="text-sm text-gray-400 mb-6">Ajoutez des véhicules à vos favoris pour les retrouver ici</p>
            <Link
              to="/annonces"
              style={{ background: '#F5A623' }}
              className="text-black px-6 py-3 rounded-xl font-bold hover:opacity-90 transition"
            >
              Parcourir les annonces
            </Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {favoris.map(annonce => (
              <div key={annonce.id} className="bg-white rounded-2xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition">
                <Link to={`/annonces/${annonce.id}`}>
                  <div className="h-44 bg-gray-100 overflow-hidden relative">
                    {annonce.photo_principale ? (
                      <img
                        src={getImageUrl(annonce.photo_principale)}
                        alt={annonce.titre}
                        className="w-full h-full object-cover hover:scale-105 transition duration-300"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center">
                        <Car size={60} className="text-gray-300" />
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="font-semibold text-gray-900">{annonce.titre}</h3>
                    <p className="font-black text-gray-900 text-lg mt-1">
                      {parseInt(annonce.prix).toLocaleString('fr-FR')} FCFA
                    </p>
                    <div className="flex gap-2 text-xs text-gray-500 mt-2">
                      <span>{annonce.annee}</span>
                      <span>•</span>
                      <span>{annonce.kilometrage.toLocaleString()} km</span>
                      <span>•</span>
                      <span className="capitalize">{annonce.carburant}</span>
                    </div>
                  </div>
                </Link>
                <div className="px-4 pb-4">
                  <button
                    onClick={() => handleSupprimer(annonce.id)}
                    className="w-full flex items-center justify-center gap-2 text-red-500 border border-red-100 py-2 rounded-xl hover:bg-red-50 transition text-sm font-semibold"
                  >
                    <Trash2 size={14} /> Retirer des favoris
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MesFavoris;